<template>
  <div class="page-dialog">
    <el-descriptions size="mini" class="margin-bottom" title="" :column="3" border>
      <el-descriptions-item label="对账单号">{{ rowData.checkBillNo }}</el-descriptions-item>
      <el-descriptions-item label="操作人">{{ rowData.createdByName }}</el-descriptions-item>
      <el-descriptions-item label="结算日期">{{ rowData.createdDate }}</el-descriptions-item>
      <el-descriptions-item label="对账周期起">{{ rowData.startday }}</el-descriptions-item>
      <el-descriptions-item label="对账周期止">{{ rowData.endday }}</el-descriptions-item>
    </el-descriptions>

    <div class="table-container">
      <TableCommon
        :pagination="pagination"
        :show-header="false"
        :custome-config="() => vxeShowCustom('xTable')"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="400"
          align="center"
          size="medium"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiFindCheckBillNoDetails } from '@/api/applyForGoods/logisticsAbnormal'

export default {
  props: {
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      conditions: {},
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 40 },
          { title: '发货单号', field: 'wantCode',width: 100 },
          { title: '客户名称', field: 'customerName',width: 160 },
          { title: '产品', field: 'productDesc',width: 180 },
          { title: '申请时间', field: 'createdDate',width: 140 },
          { title: '申请量', field: 'wantQuantity',width: 80 },
          { title: '接收时间', field: 'receiptDate',width: 140 },
          //{ title: '接收数量', field: 'acceptQty' },
          { title: '接收24小时是否反馈', field: 'feedback', width: 100 },
          { title: '备注', field: 'comment' }
        ],
        data: []
      }
    }
  },
  created() {
    if (this.rowData.checkBillNo) {
      this.queryData()
    }
  },
  methods: {
    queryData() {
      apiFindCheckBillNoDetails({ code: this.rowData.checkBillNo, ...this.pagination }).then(res => {
        const { data } = res
        this.gridOptions.data = data.Rows
        this.pagination.totalCount = data.Total
      })
    },
    handleTablePaginationChange(pagination) {
      Object.assign(this.pagination, pagination)
      this.queryData()
    }
  }
}
</script>

<style>
.margin-bottom{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/components/DeliveryCheck.vue